import { z } from 'zod'
import { useZodForm } from '@minetrace/ui/forms'

// La capacidad / producción diaria estimada se declara por derecho minero en la
// sección IGAFOM (ver useStep4IgafomForm). El paso 2 solo conserva la categoría.
export const step2AccreditationSchema = z.object({
  categoryId: z.number().min(1, 'Categoria es requerida'),
})

export type Step2AccreditationFormValues = z.infer<typeof step2AccreditationSchema>

const defaultValues: Step2AccreditationFormValues = {
  categoryId: 0,
}

export const useStep2AccreditationForm = (props?: { defaultValues?: Step2AccreditationFormValues; disabled?: boolean }) => {
  return useZodForm<Step2AccreditationFormValues>({
    validationSchema: step2AccreditationSchema,
    defaultValues: { ...defaultValues, ...props?.defaultValues },
  })
}
